export default __webpack_public_path__ + "static/4-feb796975013bffecb42bb22839e7e45.jpg";